export function setDefaultImageFormat(url, format) {
  if (url.indexOf("format=") > -1) return url;

  let newUrl = `${url}&format=${format}`;

  return newUrl;
}
